// Imports //

// Constants //
import {recaptchaSiteKeyV3} from "../configs/VD-config";

export const FAILED_TO_GET_TOKEN_STRING = "failed_to_get_token";
const recaptchaElements = document.querySelectorAll('[data-recaptcha-action]');

// Event listeners //
/**
 * init captcha on submit lsitener and
 * @param e
 * @returns {boolean}
 */
export function initCaptchaListener(e) {

    // If reCaptcha is not loaded, skip
    if (typeof grecaptcha == "undefined") {
        return true;
    }

    // Init constants and variables
    const formElement = e.detail && e.detail.form ? e.detail.form : this;
    const $this = $(formElement);
    const recaptchaAction = e.detail ? e.detail['recaptcha-action'] : $this.data("recaptcha-action");
    const tokenFieldId = `${recaptchaAction}-recaptchaToken`;
    let $tokenField = $(`#${tokenFieldId}`);

    // If the token field already exists it means we have been here already.
    if ($tokenField.length === 1) {
        if ($tokenField.val() === "") {
            // If it is still empty we are waiting for AJAX response, so skip now
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        } else {
            // If the value is already populated, submit the form.
            return true;
        }
    }

    // From now on we don't want to let the form submit
    e.stopImmediatePropagation();
    e.preventDefault();

    // Create token field and trigger the reCaptcha AJAX
    $tokenField = $(`<input type="hidden" name="recaptcha_token" id="${tokenFieldId}">`);
    $tokenField.appendTo($this);

    try {
        grecaptcha.execute(recaptchaSiteKeyV3, {action: recaptchaAction})
            .then(
                function (token) {
                    $tokenField.val(token);
                    $this.trigger("submit");
                },
                function (err) {
                    $tokenField.val(`${FAILED_TO_GET_TOKEN_STRING}|${err}`);
                    $this.trigger("submit");
                }
            );
    } catch (e) {
        $tokenField.val(`${FAILED_TO_GET_TOKEN_STRING}|${e.message}`);
        $this.trigger("submit");
    }
}
recaptchaElements.forEach((element) => {
    element.addEventListener('submit', initCaptchaListener, true);
});

export function getRecaptchaToken(action) {
    return new Promise((resolve, reject) => {
        if (typeof grecaptcha === "undefined") {
            return reject("reCaptcha is not loaded");
        }

        grecaptcha.execute(recaptchaSiteKeyV3, { action: action })
            .then(resolve)
            .catch(reject);
    });
}

